import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../../../utils/services/api.service';
import {ActivatedRoute, convertToParamMap} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {TVPROVIDER_PARAMETERS} from '../../../utils/constants/constants';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-tv-login', templateUrl: './tv-login.component.html', styleUrls: ['./tv-login.component.scss']
})
export class TvLoginComponent implements OnInit {
  private hasTourvisioProviderParameters: boolean;

  constructor(private fb: FormBuilder, private apiService: ApiService, private activatedRoute: ActivatedRoute, private notificationsService: NotificationsService) {
  }
  saveButton : boolean = true;
  group: FormGroup;
  organizationID: number;
  tvProviderParameters: any;
  viewType: any;
  public showLoading = true;
  operatorTVForm: FormGroup;
  updateOperatorTVBtn: boolean = true;
  tvParameters: any;

  ngOnInit() {
    this.initializeParameters();

    this.apiService.getOrganizationParameters(this.organizationID).subscribe(response => {
      this.tvProviderParameters = response.data.rows.filter(parameter => parameter.type === TVPROVIDER_PARAMETERS.type);
      this.hasTourvisioProviderParameters = this.tvProviderParameters.length > 0;
      this.showLoading = false;
      if(this.hasTourvisioProviderParameters){
        this.setTVParameters();
        this.setFormGroupControls();
      }
    });
  }

  saveData() {
    this.saveButton = false;
    const requests: Array<Observable<any>> = [];

    Object.keys(this.group.controls).forEach(key=> {
       if(this.group.value[key] !== ''){
        requests.push(this.createRequest(
          TVPROVIDER_PARAMETERS.type,
          this.tvParameters[TVPROVIDER_PARAMETERS.context.login][key],
          TVPROVIDER_PARAMETERS.context.login,
          key,
          this.group.value[key]
        ))
       }
    });

    if(this.hasTokenExpirationDate()){
      requests.push(this.createRequest(
        TVPROVIDER_PARAMETERS.type,
        this.tvParameters[TVPROVIDER_PARAMETERS.context.token][TVPROVIDER_PARAMETERS.keys.token.expiresOn],
        TVPROVIDER_PARAMETERS.context.token,
        TVPROVIDER_PARAMETERS.keys.token.expiresOn,
        this.getExpiredTokenDateValue()))
    }

    Observable.forkJoin(requests).subscribe(response => {
      this.notificationsService.success('Success', 'Tourvisio parametreleri eklendi.');
    }, error => {
      this.notificationsService.error('Failed', 'Save operation is failed!')
    });
  }

  createRequest(type, property, context, key, value): Observable<any> {
    if (property && property.id) {
      return this.apiService.updateOrganizationParameter(
        this.organizationID,
        property.id,
        {
          type: type,
          context: context,
          key: key,
          value: value
        }
      );
    }
    return this.apiService.addOrganizationParameter(this.organizationID, {
      type: type,
      context: context,
      key: key,
      value: value
    });
  }

  updateOperatorTourvisio(){
    this.updateOperatorTVBtn = false;
    this.createRequest(
      TVPROVIDER_PARAMETERS.type,
      this.tvParameters[TVPROVIDER_PARAMETERS.context.operator][TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio],
      TVPROVIDER_PARAMETERS.context.operator,
      TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio,
      this.operatorTVForm.controls[TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio].value
    ).subscribe(res => {
      this.notificationsService.success('Success', 'Save operation is successful!');
      this.updateOperatorTVBtn = true;
    }, err => {
      this.notificationsService.error('Failed', 'Save operation is failed!')
    });
  }

  setTVParameters(){
    this.tvProviderParameters.forEach(parameter => {
      this.tvParameters[parameter.context][parameter.key] = parameter;
    });
  }

  initializeParameters(){
    this.tvParameters = {};
    Object.keys(TVPROVIDER_PARAMETERS.context).forEach(context => {
      this.tvParameters[TVPROVIDER_PARAMETERS.context[context]] = {}
      Object.keys(TVPROVIDER_PARAMETERS.keys[context]).forEach(key => {
        let emptyValue = TVPROVIDER_PARAMETERS.context[context] === TVPROVIDER_PARAMETERS.context.operator ? '0' : '';
        this.tvParameters[TVPROVIDER_PARAMETERS.context[context]][TVPROVIDER_PARAMETERS.keys[context][key]] = {value: emptyValue}
      })
    })

    this.operatorTVForm = new FormGroup({[TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio]: new FormControl(null, Validators.required)});
    this.organizationID = this.activatedRoute.parent.snapshot.params.id;
    this.viewType = this.activatedRoute.parent.snapshot.data.viewType;
    this.setFormGroupControls();
  }

  setFormGroupControls() {
    this.group = this.fb.group(this.getLoginGroupControlsConfig());
    this.operatorTVForm.controls[TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio].patchValue(!!parseInt(this.tvParameters[TVPROVIDER_PARAMETERS.context.operator][TVPROVIDER_PARAMETERS.keys.operator.isPaximumTourvisio].value));
  }

  getLoginGroupControlsConfig(){
    const config= {};
    Object.keys(this.tvParameters[TVPROVIDER_PARAMETERS.context.login]).forEach(key => {
        config[key] = [this.tvParameters[TVPROVIDER_PARAMETERS.context.login][key].value]
    })
    return config;
  }

  hasTokenExpirationDate() {
    return this.tvParameters[TVPROVIDER_PARAMETERS.context.token] && this.tvParameters[TVPROVIDER_PARAMETERS.context.token][TVPROVIDER_PARAMETERS.keys.token.expiresOn] && this.tvParameters[TVPROVIDER_PARAMETERS.context.token][TVPROVIDER_PARAMETERS.keys.token.expiresOn].id;
  }

  getExpiredTokenDateValue() {
    const dayInMilliseconds = 24*3600*1000;
    const twoDaysAgo = Date.now() - (2*dayInMilliseconds); // date 2 days ago in milliseconds UTC
    return new Date(twoDaysAgo).toISOString();
  }

  protected readonly TVPROVIDER_PARAMETERS = TVPROVIDER_PARAMETERS;
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/tv-login/tv-login.component.ts